import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class BaseBtn extends Component {
    render() {
        const { btnColor, btnName, link, onClick, btnType, section, title } = this.props;
        return (
            <Link to={`${link}?section=${section}&title=${title}`} section={section} title={title} className={`baseBtn ${btnType} ${btnColor}`} onClick={onClick}>
                <span>{btnName}</span>
            </Link>
        );
    }
}

BaseBtn.defaultProps = {
    btnColor: 'blue',
    btnName: 'Button',
    link: '#',
    btnType: '',
    section: '',
    title: ''
}

export default BaseBtn;


// WEBPACK FOOTER //
// ./src/components/Buttons/BaseBtn/index.js